import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import VisibilitySensor from 'react-visibility-sensor'
import Loader from '@components/loader/1'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
const Kpi1 = (props: RealEstateDataPageComponentData) => {
  const { kpis, kpiAnimation } = props
  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  const [load, setLoad] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 0)
  }, [])

  const KpiItemTitle = (value: string, simbol: any = null) => {
    if (kpiAnimation) {
      return (
        <div>
          {inView && kpiAnimation && (
            <VisibilitySensor
              partialVisibility
              offset={{ bottom: 50 }}
            >
              <h2 className="kpi-title">
                {simbol ? <span className="kpi-simbol ">{simbol}</span> : null}
                <CountUp
                  start={0}
                  duration={5}
                  className="kpi-countup "
                  end={parseInt(value)}
                />
              </h2>
            </VisibilitySensor>
          )}
        </div>
      )
    } else {
      return (
        <h2 className="kpi-title">
          {simbol ? <span className="kpi-simbol ">{simbol}</span> : null}
          <span className="kpi-countup">{value}</span>
        </h2>
      )
    }
  }

  return (
    <section
      id="kpi-container"
      ref={ref}
      className={'p-y-config' + (kpis?.length === 0 ? ' d-none' : '')}
    >
      <Container fluid>
        {!load ? (
          <>
            <Row className="justify-content-center">
              <Col lg={10}>
                <div
                  className={
                    'kpi-wrapper d-flex justify-content-start flex-wrap' +
                    (kpis && kpis?.length > 3
                      ? ' justify-content-lg-around'
                      : ' justify-content-lg-around')
                  }
                >
                  {kpis && kpis?.length !== 0
                    ? kpis?.map((kpi, i) => (
                        <div
                          className="kpi-item"
                          key={i}
                        >
                          <div
                            className={
                              'kpi d-flex align-items-center justify-content-lg-start justify-content-center text-center text-lg-start' +
                              (!kpi?.title ? ' justify-content-lg-center' : '')
                            }
                          >
                            {kpi?.value ? KpiItemTitle(kpi?.value, kpi?.simbol || null) : null}
                            {kpi?.title ? (
                              <span className="kpi-subtitle ">{kpi?.title}</span>
                            ) : (
                              <span className="kpi-space d-inline-block"></span>
                            )}
                          </div>
                          {kpi?.paragraph ? (
                            <p className="kpi-paragraph">{kpi?.paragraph}</p>
                          ) : null}
                        </div>
                      ))
                    : null}
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <Loader />
        )}
      </Container>
    </section>
  )
}

export default Kpi1
